// src/pages/ContentDetail/components/ContentTabs.js
import React from 'react';
import { Box, Paper, Tabs, Tab, alpha } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ActivityContent from './ActivityContent';
import TabPanel from '../../../../components/common/TabPanel';

// A11y props for tabs
function a11yProps(index) {
  return {
    id: `content-tab-${index}`,
    'aria-controls': `content-tabpanel-${index}`,
  };
}

const ActivityTabs = ({ activities, value, onChange }) => {
  const theme = useTheme();
  
  return (
    <Paper
      sx={{
        borderRadius: 1,
        bgcolor: theme.palette.background.paper,
        boxShadow: 'none',
        border: '1px solid',
        borderColor: alpha(theme.palette.common.white, 0.1)
      }}
    >
      <Box sx={{ borderBottom: 1, borderColor: alpha(theme.palette.common.white, 0.1) }}>
        <Tabs
          value={value}
          onChange={onChange}
          aria-label="content tabs"
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor: theme.palette.primary.main,
              height: 3
            },
            '& .MuiTab-root': {
              color: theme.palette.text.secondary,
              '&.Mui-selected': {
                color: theme.palette.primary.main
              }
            }
          }}
        >
          {activities.map((activity, index) => (
            <Tab
              key={activity.id}
              label={activity.activityTitle}
              {...a11yProps(index)}
            />
          ))}
        </Tabs>
      </Box>

      {/* Render each activity's content */}
      {activities.map((activity, index) => (
        <TabPanel key={activity.id} value={value} index={index}>
          <ActivityContent activity={activity} />
        </TabPanel>
      ))}
    </Paper>
  );
};

export default ActivityTabs;